import Constant from '@/common/constant/Constant';
import localStorageUtil from '@/common/utils/localStorageUtil';
import Utils from '@/common/utils/utils';
import LoadingPanel from '@/component/common/LoadingPanel';
import {
    checkDisplayTabsCustomer
} from '@/component/project/handler/ProjectUserManagementHandler';
import { corporationAtom } from '@/state/atom/corporationAtom';
import { projectInuseDetailAtom } from '@/state/atom/projectAtom';
import { userAtom } from '@/state/atom/userAtom';
import { isManagerByProjectInuseSelector } from '@/state/selector/projectSelector';
import {
    AppBar, Tab, Tabs
} from '@material-ui/core';
import { Auth } from 'aws-amplify';
import { useSnackbar } from 'notistack';
import { useEffect, useState } from 'react';
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import CustomerListInCorporation from './CustomerListInCorporation';
import CustomerListInProject from './CustomerListInProject';
import './ProjectUserManagement.css';
import UserListInProject from './UserListInProject';
import BusinessCustomerListInProject from './BusinessCustomerListInProject';
import CancelTabsDialog from '../system/dialog/CancelTabsDialog';
import { closeTabId, multiPanelAtom } from '@/state/atom/panelAtom';
import { closePanelTabSelector } from '@/state/selector/panelSelector';
import trI18n from '@/common/utils/trI18n';
import { useTranslationSubscription } from '@/hooks/useTranslation';

export default function ProjectCustomerManagement(props) {
    // Re-render when the translation dictionary loads/updates.
    useTranslationSubscription();

    const { enqueueSnackbar } = useSnackbar();
    const [isLoading, setIsLoading] = useState(false);

    // common userDetail state
    const userDetail = useRecoilValue(userAtom);

    // common corporationDetail state
    const corporationDetail = useRecoilValue(corporationAtom);

    // common projectInuse state
    const projectDetail = useRecoilValue(projectInuseDetailAtom);

    // check is admin
    const isAdmin = Utils.isAdminUser(userDetail);

    // check is pm
    let currentIsProjectManager = useRecoilValue(isManagerByProjectInuseSelector);
    const [isProjectManager, setIsProjectManager] = useState(currentIsProjectManager);

    const [tabSelected, setTabSelected] = useState(Constant.PROJECT_USER_TAB_MANAGEMENT.TAB_B2C_CUSTOMER_MANAGEMENT);

    const closePanelTab = useSetRecoilState(closePanelTabSelector);
    const [closeTabIdState, setCloseTabIdState] = useRecoilState(closeTabId);
    const [panelList, setPanelList] = useRecoilState(multiPanelAtom);
    const [isConfirmCancelTabs, setIsConfirmCancelTabs] = useState(false);
    const [isChangeData, setIsChangeData] = useState(false);

    const [isDisplayB2CTab, setIsDisplayB2CTab] = useState(false);
    const [isDisplayB2BTab, setIsDisplayB2BTab] = useState(false);

    let argsAll = {
        ...props,
        API: props?.API,
        corporationDetail,
        corporationId: corporationDetail.id,
        corporationSubdomain: localStorageUtil.getCorporationDomain(),
        projectId: localStorageUtil.getSelectedProjectId(),
        username: Auth.user.username,
        userDetail,
        setIsLoading,
        enqueueSnackbar,
        projectDetail,
        tabSelected,
        setTabSelected,
        isProjectManager,
        setIsProjectManager,
        isAdmin,
        panelList,
        setPanelList,
        closePanelTab,
        isConfirmCancelTabs,
        setIsConfirmCancelTabs,
        isDisplayB2CTab, 
        setIsDisplayB2CTab,
        isDisplayB2BTab, 
        setIsDisplayB2BTab
    };

    useEffect(() => {
        setIsLoading(true);
        checkDisplayTabsCustomer(argsAll, tabSelected).then(() => {
            setIsLoading(false);
        })
    }, [userDetail])

    useEffect(() => {
        if (props.tabId === closeTabIdState) {
            if (
                (isChangeData && projectDetail.type === Constant.PROJECT_TYPE.CUSTOMER) ||
                (isChangeData && Utils.isPublicDesk(projectDetail))
            ) {
                setIsConfirmCancelTabs(true);
            } else {
                let currentPanelInfo = Utils.getPanelInfo(props.panelId, panelList);
                if (!currentPanelInfo || Utils.isEmptyObject(currentPanelInfo)) return;
                closePanelTab({
                    event: null,
                    panelType: currentPanelInfo.type,
                    panelId: props.panelId,
                    tabId: props.tabId
                });
            }
            setCloseTabIdState(0);
        }
    },[closeTabIdState]);

    useEffect(() => {
        // set is project manager when change
        setIsProjectManager(currentIsProjectManager);
    }, [currentIsProjectManager]);

    const onChangeTab = (event, newValue) => {
        setTabSelected(newValue);
    };

    const isChangeDataPj = (child) => {
        setIsChangeData(child)
    }

    const renderContentTab = tabSelect => {
        switch (tabSelect) {
            case Constant.PROJECT_USER_TAB_MANAGEMENT.TAB_B2C_CUSTOMER_MANAGEMENT: {
                return <CustomerListInProject {...argsAll} parentCallBack={isChangeDataPj} />;
            }
            case Constant.PROJECT_USER_TAB_MANAGEMENT.TAB_B2B_CUSTOMER_MANAGEMENT: {
                return <BusinessCustomerListInProject {...argsAll} parentCallBack={isChangeDataPj} />
            }
            default: {
                return <></>;
            }
        }
    };

    return (
        <div className="projectUser">
            <LoadingPanel isLoading={isLoading} />

            <div className="tabList">
                <div className="navTabs">
                    <AppBar className="navTabs-box" position="static">
                        <Tabs
                            className="navTabs-rot"
                            value={tabSelected}
                            indicatorColor="primary"
                            textColor="primary"
                            variant="scrollable"
                            scrollButtons="auto"
                            aria-label="scrollable auto tabs example"
                            onChange={onChangeTab}
                        >
                            { isDisplayB2CTab && 
                                <Tab
                                    className="navTabs--item custom-tab"
                                    label={trI18n('USER03BTN007')}
                                    value={Constant.PROJECT_USER_TAB_MANAGEMENT.TAB_B2C_CUSTOMER_MANAGEMENT}
                                    aria-selected="false"
                                />
                            }

                            { isDisplayB2BTab && 
                                <Tab
                                    className="navTabs--item custom-tab"
                                    label={trI18n('USER03BTN008')}
                                    value={Constant.PROJECT_USER_TAB_MANAGEMENT.TAB_B2B_CUSTOMER_MANAGEMENT}
                                    aria-selected="false"
                                />
                            }
                        </Tabs>
                    </AppBar>
                </div>
            </div>
            {renderContentTab(tabSelected)}
            <CancelTabsDialog argsAll={argsAll}/>
        </div>
    );
}
